module.exports = __webpack_public_path__ + "img/logo_2.6e4574f6.svg";